import React from 'react';
import { GraphImage } from '../../types';

export const UnsplashLinks = ({ imageLinked }: { imageLinked: GraphImage }) => {
  return (
    <div data-testid="unsplash-attribution" className="unsplash-attribution">
      <span className="unsplash-author">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={imageLinked.authorUrl}
        >
          {imageLinked.author}
        </a>
      </span>
      <span className="unsplash-link">
        {' '}
        for{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://unsplash.com/?utm_source=${process.env.UNSPLASH_APP_ID}&utm_medium=referral`}
        >
          Unsplash
        </a>
      </span>
    </div>
  );
};
